<template>
    <div class='content border-radius'>
        <h3 class='titre'>
            {{ $t('dashboard.fournisseur.factures.title', {dateDebut: dateDebut, dateFin: dateFin}) }}
            <ReglePastille cle="dashboardFournisseur.statutsFactures" />
        </h3>

        <div class='items-container'>
            <div class='a-valider border-radius item' @click='setFilterAValider'>
                <span class='nombre'>{{getStatsFactures?.nbAValider}}</span>
                <span class='texte'> {{ $t('dashboard.fournisseur.factures.avalider') }}</span>
            </div>
            <div class='validees border-radius item' @click='setFilterValidees'>
                <span class='nombre'>{{getStatsFactures?.nbValidees}}</span>
                <span class='texte'> {{ $t('dashboard.fournisseur.factures.validees') }}</span>
            </div>
            <div class='litige border-radius item' @click='setFilterLitige'>
                <span class='nombre'>{{getStatsFactures?.nbLitige}}</span>
                <span class='texte'> {{ $t('dashboard.fournisseur.factures.litige') }}</span>
            </div>
            <div class='rejetees border-radius item' @click='setFilterRejetees'>
                <span class='nombre'>{{getStatsFactures?.nbRejetees}}</span>
                <span class='texte'>{{ $t('dashboard.fournisseur.factures.rejetees') }}</span>
            </div>
            <div class='payees border-radius item' @click='setFilterPayees'>
                <span class='nombre'>{{getStatsFactures?.nbPayees}}</span>
                <span class='texte'>{{ $t('dashboard.fournisseur.factures.payees') }}</span>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { FactureFournisseurStatsDTO } from '@/models/FactureFournisseurStatsDTO';
import { FACTURE_FOURNISSEUR } from '@/modules/FacturesFournisseurs/store/mutation-types';
import { StatusFacture } from '@/models/FactureFournisseurDTO';
import dayjs from 'dayjs';
import ReglePastille from '@/components/regles/ReglePastille.vue';

export default defineComponent({
    name: 'WidgetFacture',
    components: { ReglePastille },
    props: {
        // stats: { type: FactureFournisseurStatsDTO, required: true },
    },
    data() {
        return {
            dateDebut: dayjs().subtract(2, 'year').format('DD/MM/YY'),
            dateFin: dayjs().format('DD/MM/YY')
        };
    },
    computed: {
        getStatsFactures(): FactureFournisseurStatsDTO {
            return this.$store.getters['dashboardFournisseurState/getStatsFactures'];
        }
    },
    methods: {
        setFilterAValider(): void {
            this.$store.commit(`factureFournisseurState/${FACTURE_FOURNISSEUR.SET_FILTER_DATE_DEBUT}`, dayjs().startOf('day').subtract(2, 'year').format('YYYY-MM-DD') );
            this.$store.commit(`factureFournisseurState/${FACTURE_FOURNISSEUR.SET_FILTER_ETAT}`, [StatusFacture.aValider]);
            this.$router.push('/factures-fournisseur');
        },
        setFilterValidees(): void {
            this.resetItemsAndSetDate();
            this.$store.commit(`factureFournisseurState/${FACTURE_FOURNISSEUR.SET_FILTER_ETAT}`, [StatusFacture.valide]);
            this.$router.push('/factures-fournisseur');
        },
        setFilterLitige(): void {
            this.resetItemsAndSetDate();
            this.$store.commit(`factureFournisseurState/${FACTURE_FOURNISSEUR.SET_FILTER_ETAT}`, [StatusFacture.litige]);
            this.$router.push('/factures-fournisseur');
        },
        setFilterRejetees(): void {
            this.resetItemsAndSetDate();
            this.$store.commit(`factureFournisseurState/${FACTURE_FOURNISSEUR.SET_FILTER_ETAT}`, [StatusFacture.rejetee]);
            this.$router.push('/factures-fournisseur');
        },
        setFilterPayees(): void {
            this.$store.commit(`factureFournisseurState/${FACTURE_FOURNISSEUR.SET_FILTER_DATE_DEBUT}`, dayjs().subtract(2, 'year').format('YYYY-MM-DD') );
            this.resetItemsAndSetDate();
            this.$store.commit(`factureFournisseurState/${FACTURE_FOURNISSEUR.SET_FILTER_ETAT}`, [StatusFacture.payee]);
            this.$router.push('/factures-fournisseur');
        },
        resetItemsAndSetDate(): void {
            this.$store.commit(`factureFournisseurState/${FACTURE_FOURNISSEUR.SET_FILTER_DATE_DEBUT}`, dayjs().startOf('day').subtract(2, 'year').format('YYYY-MM-DD') );
            this.$store.commit(`factureFournisseurState/${FACTURE_FOURNISSEUR.RESET_ITEMS}`);
        }
    }
});
</script>

<style scoped>
.content {
    background-color: white;
    padding: 10px 30px 30px;
    height: 44vh;
    box-shadow: 5px 4px 5px 0 rgba(0, 0, 0, 0.1);
}
@media screen and (max-width: 900px) and (max-height: 700px) {
    .content {
        height: 100% !important;
        padding: unset;
    }
}
.a-valider {
    background-color: #75a9f9;
}
.validees {
    background-color: #92d36e;
}
.litige {
    background-color: #f06e9c;
}
.rejetees {
    background-color: #ffb253;
}
.payees{
    background-color: #800080;
}
.border-radius {
    border-radius: 20px;
}
.items-container {
    display: flex;
    flex-wrap: wrap;
    height: 89%;
    justify-content: center;
}
.item {
    display: flex;
    align-items: center;
    width: 100%;
    margin: 10px;
    color: white;
    cursor: pointer;
}
.nombre {
    font-size: 3vh;
    display: flex;
    justify-content: center;
    margin-left: 15px;
}
.texte {
    font-size: 1.3em;
    display: flex;
    justify-content: center;
    margin-left: 2px;
}
@media (max-height: 700px) {
    .nombre {
        font-size: 4vh;
    }
    .titre {
        margin-block-start: 0.5em;
        margin-block-end: 0;
    }
}
@media (max-height: 600px) {
    .items-container {
        display: flex;
        flex-wrap: wrap;
        height: 72%;
        justify-content: center;
    }
}
@media (max-width: 984px) {
    .content {
        height: 68vh;
    }
}
@media (max-width: 1195px) {
    .content {
        height: 68vh;
    }
}
@media (max-width: 1790px) {
    .items-container {
        height: 80%;
    }
}
</style>
